<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <!-- logo -->
    <div class="index-logo">
      <img class="index-logo-img" src="/static/image/logo-red.png" alt="" />
    </div>
    <!-- background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF" -->

    <!-- 左侧导航 -->
    <el-menu
      :show-timeout="200"
      :default-active="activeMenu"
      :collapse="isCollapse"
      mode="vertical"
      :unique-opened="true"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#15bd8a"
    >
      <sidebar-item v-for="(route, index) of permission_routers" :key="index" :item="route" :base-path="route.path" />
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(['permission_routers', 'sidebar']),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    isCollapse() {
      return !this.sidebar.opened
    },
  },
}
</script>
<style rel="stylesheet/scss" lang="scss">
.index-logo {
  // position: fixed;
  // z-index: 9;
  // left: 0px;
  // top: 0px;
  width: 220px;
  height: 50px;
  // background: rgb(48, 65, 86);
  // background: #001528;
  background: #1f2d3d;

  // background: #fff;
  box-sizing: border-box;
  padding-left: 36px;
  padding-top: 14px;
  // border-right: 1px solid #EBEEF5;
}
.index-logo-img {
  display: block;
  height: 22px;
  // margin: 12px auto 0;
}
</style>
